import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { Button } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const Content = styled.div(
    ({ theme }: ParamsStyle) => `
        display: flex;
        gap: .875rem;
        padding: 0 0 2.1875rem;
        flex-direction: column;
`);

export const ButtonCustom = styled(Button)(
    ({ theme }: ParamsStyle) => `
        min-width: 0px;
        font-size: .75rem;
        font-weight: 600;
        margin: 0px;
        padding: 0px;
        border-radius: 5px;
`);

export const TypographyLabel = styled(Typography)(
    ({ theme }: ParamsStyle) => `
        font-weight: 600;
        line-height: 1rem;
        font-size: .75rem;
        color: ${theme?.palette.grey[400]};
`);

export const TypographyText = styled(Typography)(
    ({ theme }: ParamsStyle) => `
        font-weight: 400;
        line-height: 1rem;
        font-size: .75rem;
        color: ${theme?.palette.primary.main};
`);

export const ContainerRowNav = styled.div(
    ({ theme }: ParamsStyle) => `
        display: grid;
        padding-top: .5rem;
        justify-content: space-between;
        grid-template-columns: 5.3rem 6.3rem 7.56rem;
`);
